import { render, staticRenderFns } from "./AIChat.vue?vue&type=template&id=ad8bd6fa&scoped=true"
import script from "./AIChat.vue?vue&type=script&lang=js"
export * from "./AIChat.vue?vue&type=script&lang=js"
import style0 from "./AIChat.vue?vue&type=style&index=0&id=ad8bd6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8bd6fa",
  null
  
)

export default component.exports